var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInteractiveEmbeddingOn = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 32,
  fill: "none",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#InteractiveEmbeddingOn_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 37.5,
  height: 29.5,
  x: 1.25,
  y: 1.25,
  stroke: "#CBE2F7",
  strokeWidth: 2.5,
  rx: 2.75
}), /*#__PURE__*/React.createElement("path", {
  fill: "#509EE3",
  fillRule: "evenodd",
  d: "M18.527 17.473 13 16l5.527-1.473L20 9l1.473 5.527L27 16l-5.527 1.473L20 23zM29.369 8.631 27 8l2.369-.631L30 5l.631 2.369L33 8l-2.369.631L30 11zM29.974 24.026 28 23.5l1.974-.526L30.5 21l.526 1.974L33 23.5l-1.974.526L30.5 26zM8.974 11.026 7 10.5l1.974-.526L9.5 8l.526 1.974L12 10.5l-1.974.526L9.5 13z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "InteractiveEmbeddingOn_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v32H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInteractiveEmbeddingOn);
export default ForwardRef;